

// * 获取google 全天买量数据

import { DatePicker, Flex, Form, Modal, Select } from "antd";
import { useTypedDispatch, useTypedSelector } from "@/hooks/store.hook";
import { MODAL_TYPE } from "@/store/reducers/modalSlice";
import { useForm } from "antd/es/form/Form";
import dayjs from 'dayjs';
import { _message } from "@/components/message";
import { getSnapFlowDataOfAllDay } from '@/service/adjustRoi.service';
import { getSitesData } from '@/service/adjustRoi.service';
import { useEffect, useMemo, useState } from "react";
import { _setAlert } from "@/components/alert";


export default function SnapModal() {

    const { type, status } = useTypedSelector(state => state.modalReducer);
    const dispatch = useTypedDispatch();
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const [sites, setSites] = useState([]);

    const onOk = async () => {
        setLoading(true);
        try{
            await form.validateFields();
            const values = form.getFieldsValue();
            values['queryDate'] = values['queryDate'].format('YYYY-MM-DD');
            const result = await getSnapFlowDataOfAllDay(values);
            setLoading(false);
            if(result.code === 200) {
                _setAlert({ type: 'success', message: '获取snap数据:' + (result.msg || '成功') });
            }else{
                _setAlert({ type: 'error', message: '获取snap数据:' + result.msg });
            }
            if(!result){
                _setAlert({ type: 'error', message: '请求超时,可能是网络问题' });
            }
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    _setAlert({ type: 'error', message: '获取snap数据失败:' + (v.errors.join(','))})
                })
            }
            setLoading(false);
        }
    }

    const onCancel = () => {
        dispatch({ type: "modal/hideModal"})
    }


    const filter = (inputValue: string, path: any) => {
        const isArray = Array.isArray(path);
        switch (isArray) {
            case true:
                const inputs = inputValue.split('/');
                return inputs.length > 1  ? inputs.every(input => path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(input.toLowerCase()) > -1)) : path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            default:
                return path.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        }
    }


    const siteOptions = useMemo(() => {
        if(sites.length){
            return sites.map((item: {id:Number, site: string}) => ({ label: item.site, value: item.site }))?.sort((a, b) => a?.label?.localeCompare(b?.label));
        }
        return [];
    }, [sites])

    const initSitesOptions = async () => {
        try {
            const { code, data } = await getSitesData();
            if (code === 200) {
                setSites(data);
            }
        } catch (error) {
            _message.error('系统错误');
        } 
    };

    useEffect(() => {
        initSitesOptions();
    }, []);


    return <Modal onOk={onOk} open={status && type === MODAL_TYPE.snap} onCancel={onCancel} cancelText={'关闭'} confirmLoading={loading}>
        <Form form={form} layout="inline" initialValues={{ queryDate: dayjs() }}>
            <Flex vertical={true} gap="large">
                <Form.Item name='site' label="站点" rules={[{ required: true, message: '站点不能为空' }]}>
                    <Select listHeight={450} allowClear={true} showSearch={true} filterOption={filter} placeholder="站点" style={{ minWidth: 260, marginLeft: '2ch' }} options={siteOptions}></Select>
                </Form.Item>
                <Form.Item name="queryDate" label="日期" required={true} rules={[{ required: true, message: '日期不能为空' }]}>
                    <DatePicker style={{ minWidth: 260, marginLeft: '2ch' }}></DatePicker>
                </Form.Item>
            </Flex>
        </Form>
    </Modal>
}